import Container from "components/Container";
import { useBreadcrumb } from "features/breadcrumbs";
import ExportCertidaoNegativaDebitos from "components/CertidaoNegativaDebitos/ExportCertidaoNegativaDebitos";
import CardDefault from "components/Cards/CardDefault";
import PageHeader from "components/Page/PageHeader";

function CertidaoNegativaDebitos() {
  useBreadcrumb([
    { name: "Relatórios" },
    {
      name: "Certidão negativa de débitos",
      url: "/relatorios/unidades/certidao-negativa-debitos",
    },
  ]);

  return (
    <Container>
      <PageHeader title="Gerar certidão negativa de débitos" />

      <CardDefault>
        <ExportCertidaoNegativaDebitos />
      </CardDefault>
    </Container>
  );
}

export default CertidaoNegativaDebitos;
